import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c25de2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog message-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100 fs-9" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "text-center fs-8"
}
const _hoisted_9 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_10 = { class: "d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import { PropType } from 'vue'
import Button from '@/components/button/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: String,
    require: true,
  },
  header: {
    type: String,
    require: true,
  },
  contentMessage: {
    type: String,
    require: true,
  },
  subContentMessage: {
    type: String,
    require: true,
  },
  button: {
    type: String,
    default: translate('close'),
  },
  buttonClick: {
    type: Function as PropType<() => void | undefined>,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: __props.id,
    tabindex: "-1",
    "aria-labelledby": __props.id,
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.header), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(['text-center', __props.subContentMessage ? 'fw-bold' : ''])
          }, _toDisplayString(__props.contentMessage), 3),
          (__props.subContentMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.subContentMessage), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Button, {
              title: __props.button,
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2",
              onClick: __props.buttonClick
            }, null, 8, ["title", "onClick"])
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})